import { VariableType } from 'json-to-graphql-query';

import { PermissionRelationObjectType } from '@/interfaces/permissionRelationObjectType';
import { Resource } from './resource';

/**
 * Resource uprawnień ról
 *
 * @export
 * @class PermissionRelationResource
 * @extends {Resource}
 */
export class PermissionRelationResource extends Resource {
  /**
   * Pobieranie listy
   *
   * @param {number} roleId
   * @returns {Promise<PermissionRelationObjectType[]>}
   * @memberof PermissionRelationResource
   */
  public list(roleId: number): Promise<PermissionRelationObjectType[]> {
    const query = this.prepareOptions({
      query: {
        __variables: { roleId: 'Int!' },
        rolePermissionList: {
          __args: { roleId: new VariableType('roleId') },
          fromParent: true,
          allowed: true,
          permission: {
            id: true,
            name: true
          }
        }
      }
    });
    return this.query(
      {
        query,
        variables: { roleId }
      },
      'rolePermissionList'
    );
  }

  /**
   * Usunięcie uprawnienia
   *
   * @param {number} permissionId
   * @param {number} roleId
   * @returns {Promise<number>}
   * @memberof PermissionRelationResource
   */
  public delete(permissionId: number, roleId: number): Promise<number> {
    const mutation = this.prepareOptions({
      mutation: {
        __variables: { permissionId: 'Int!', roleId: 'Int!' },
        rolePermissionDelete: {
          __args: { permissionId: new VariableType('permissionId'), roleId: new VariableType('roleId') }
        }
      }
    });
    return this.mutation(
      {
        mutation,
        variables: { permissionId, roleId }
      },
      'rolePermissionDelete'
    );
  }

  /**
   * Dodawanie uprawnienia
   *
   * @param {number} permissionId
   * @param {number} roleId
   * @returns {Promise<number>}
   * @memberof PermissionRelationResource
   */
  public add(permissionId: number, roleId: number): Promise<number> {
    const mutation = this.prepareOptions({
      mutation: {
        __variables: { permissionId: 'Int!', roleId: 'Int!' },
        rolePermissionAdd: {
          __args: { permissionId: new VariableType('permissionId'), roleId: new VariableType('roleId') }
        }
      }
    });
    return this.mutation(
      {
        mutation,
        variables: { permissionId, roleId }
      },
      'rolePermissionAdd'
    );
  }
}

export const permissionRelationResource = new PermissionRelationResource();
